import { render, staticRenderFns } from "./PromoterConfig.vue?vue&type=template&id=408ab2b9"
import script from "./PromoterConfig.vue?vue&type=script&lang=js"
export * from "./PromoterConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports